import React from 'react';
import moment from 'moment';
import { View, Text } from 'react-native';
import { useStyleSheet, useThemeContext } from '../../../hooks';
import { createStyleSheet, getAppointmentColor } from '../../../utils';
import { Focusable } from '../../Focusable';
import { useCalendarContext } from '../contexts';
export const Day = (props) => {
    var _a, _b, _c, _d;
    const { active, setActive } = useCalendarContext();
    const { color } = useThemeContext();
    const isEditing = Boolean(props.selected && props.onSelect);
    const isSelected = (_a = props.selected) === null || _a === void 0 ? void 0 : _a.some((day) => moment(props.day).isSame(moment(day), 'day'));
    const isHighlighted = (_b = props.highlighted) === null || _b === void 0 ? void 0 : _b.some((day) => moment(props.day).isSame(moment(day), 'day'));
    const isActive = !isEditing && moment(props.day).isSame(moment(active), 'day');
    const isToday = moment(props.day).isSame(moment(), 'day');
    const styles = useStyleSheet(getStyles);
    const onPress = () => {
        setActive(props.day);
    };
    const isStart = isSelected &&
        ((_c = props.highlighted) === null || _c === void 0 ? void 0 : _c.some((day) => moment(props.day).add(1, 'day').isSame(moment(day), 'day')));
    const isEnd = isSelected && !isStart;
    return (React.createElement(View, { style: styles.container },
        isHighlighted && (React.createElement(View, { style: [
                styles.highlighterContainer,
                isEnd && styles.highlighterContainer__end,
                props.size === 'lg' && styles.highlighterContainer__lg
            ] },
            React.createElement(View, { style: [
                    styles.highlighter,
                    isStart && styles.highlighter__start,
                    isStart && props.size === 'lg' && styles.highlighter__edge__lg
                ] }),
            React.createElement(View, { style: [
                    styles.highlighter,
                    isEnd && styles.highlighter__end,
                    isEnd && props.size === 'lg' && styles.highlighter__edge__lg
                ] }))),
        React.createElement(Focusable, { style: [
                styles.wrapper,
                props.size === 'lg' && styles.wrapper__lg,
                isToday && styles.today,
                isActive && styles.active,
                isSelected && styles.selected,
                isSelected && props.size === 'lg' && styles.selected__lg
            ], onPress: () => {
                onPress();
                if (isEditing) {
                    props.onSelect(moment(props.day).toISOString());
                }
            }, disabled: props.disabled, hoverStyle: isActive || isToday ? {} : styles.hover }, ({ hovered }) => (React.createElement(Text, { style: [
                styles.text,
                hovered ? styles.textHover : {},
                isToday ? styles.textToday : {},
                isActive ? styles.textActive : {},
                isSelected || isHighlighted ? styles.selectedText : []
            ] }, new Date(props.day).getDate().toString()))),
        props.showAppointments && (React.createElement(View, { style: styles.appointments }, (_d = props.appointmentsByDay) === null || _d === void 0 ? void 0 : _d.slice(0, 3).map((appointment, index) => {
            return (React.createElement(View, { key: appointment.id, style: [
                    styles.appointment,
                    index !== 0 ? styles.appointmentWithMargin : {},
                    {
                        backgroundColor: getAppointmentColor(color, appointment.status)
                    }
                ] }));
        })))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
        flexBasis: 0
    },
    wrapper: {
        height: size.M,
        width: size.M,
        borderRadius: 9999,
        justifyContent: 'center',
        alignItems: 'center',
        top: 0
    },
    wrapper__lg: { height: size.K * 2, width: size.K * 2 },
    highlighterContainer: {
        position: 'absolute',
        height: size.M,
        width: '100%',
        left: 0,
        top: 0,
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    highlighterContainer__lg: { height: size.K * 2 },
    highlighterContainer__end: { justifyContent: 'flex-start' },
    highlighter: { backgroundColor: color.primary.ghost, width: '50%' },
    highlighter__start: {
        borderTopLeftRadius: 9999,
        borderBottomLeftRadius: 9999,
        width: size.M / 2
    },
    highlighter__end: {
        borderTopRightRadius: 9999,
        borderBottomRightRadius: 9999,
        width: size.M / 2
    },
    highlighter__edge__lg: { width: size.K },
    selected: {
        backgroundColor: color.primary.ghost,
        borderWidth: 1,
        borderColor: color.primary.solid
    },
    selected__lg: { borderWidth: 2 },
    selectedText: { color: color.primary.solid },
    active: { backgroundColor: color.primary.solid },
    hover: {
        backgroundColor: color.primary.ghostHover
    },
    today: {
        backgroundColor: color.primary.ghost
    },
    text: {
        fontWeight: '500',
        fontSize: size.F,
        lineHeight: size.H,
        color: color.invert2.p68
    },
    textActive: {
        color: color.white.p100
    },
    textToday: {
        color: color.primary.solid
    },
    textHover: {
        color: color.primary.solidHover
    },
    appointments: {
        width: size.M,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginVertical: size.B,
        height: 6
    },
    appointment: {
        width: 6,
        height: 6,
        backgroundColor: 'black',
        borderRadius: 3
    },
    appointmentWithMargin: {
        marginLeft: size.B
    }
}));
//# sourceMappingURL=Day.js.map